
const Header=()=>{
    return <div className="header sticky top-0 left-0 right-0 h-16 px-24 bg-gradient-to-r from-[#181933] to-[#32325D] text-white py-4">
    
    <div className=" flex gap-3">
    <h1 className="text-xl font-bold font-poppins ">YOURAINA</h1>
        <div >Home</div>
        <div>Feature</div>
        <div>About</div>
        <div>Contact</div>
    </div>
   
</div>

}

export default Header